<template>
  <div class="absolute top-0 z-50  w-full h-full flex items-center justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>

    <div class=" orderPanel  absolute flex flex-col m-auto w-10/12 md:w-4/5 md:max-w-sm rounded bg-slate-200">
      <div class="flex border-b border-blue-400 p-2">
        <div class="ml-auto font-bold text-xl">Update User Password</div>
        <div v-on:click="close()" class=" ml-auto w-8 h-8 bg-slate-100 border-slate-300 rounded-full flex active:scale-75 hover:scale-105">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" w-7 h-7 m-auto">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        </div>
      </div>

      <div class=" md:h-auto" >
        
        <div class=" flex flex-col p-6">

          <input class=" m-2 md:m-4" type="password" v-model="password" placeholder="Enter Password" />
          <input class=" m-2 md:m-4" type="password" v-model="password2" placeholder="ReEnter Password" />
          
           <p v-if="errors.length">
            <b>Please correct the following error(s):</b>
              <ul class=" text-red-500">
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </p>
          
           <button 
            class=" bg-gray-200 font-bold text-gray-600 cursor-pointer shadow p-2 mx-auto" 
            v-on:click="updatePassword()"> 
            Update Password
          </button>
          
        
        </div>
      </div>
    
    
    </div>

  
  </div>
</template>

<script>
// @ is an alias to /src

import axios from "axios";
export default {
  name: 'UpdateUserPassword',
  components: {
    // signUpPage: SignUpPage,
  },
  data () {
       return{
        
        password:'',
        password2:'',

        errors: [],
        BackendUrl: "https://labsapi.packymstechnology.com"
       }
      },
  methods:{
   async updatePassword(){
    this.checkForm();
     if(this.errors.length){
       // this.warnShakeError()
        console.log("Still have an Error")
      }
      else{
        this.$parent.showLoading(true)
        let dev = process.env.VUE_APP_DEVELOPMENT;    
        if (dev == "true") {
          console.log("is in dev mode")
          this.BackendUrl = "";
        }
        try {
          let result = await axios.put(this.BackendUrl + "/users/uup", {
          password:this.password          
        },{
          headers:{
            Authorization : `Bearer ${JSON.parse(localStorage.getItem('account')).access_token}`
          },
        });

        console.log(result)

        if(result.status == 200){
          // alert("Signed up ready to login")
          this.$parent.showUpdateUserPassword(false);
          // localStorage.setItem('account', JSON.stringify(result.data))
          this.$parent.setMessageBox("User Password has been updated.", "accepted")
          this.$parent.showProfile(true)
        } else {
          alert("there was an error")
          
        }
        } catch (error) {
          const code = error.response.status
          if(code == 403){
            this.$parent.setMessageBox("Username or email already taken", "warning")
          } else{
            this.$parent.setMessageBox("Something went wrong, Please check your internet connection or try again later", "error")
          }
        }
        
        this.$parent.showLoading(false)
        }
    
    },
    checkForm(){
            this.errors = [];
           
            if (!this.password) {
              this.errors.push("Password is required.");
            }else if(this.password.length < 6){
              this.errors.push("Password need to be atleast 6 characters.");
            } else{             
              if (this.password != this.password2) {
                this.errors.push("Re-entered password does not match");
              }
            }
           
        },
        
   
    close(){
      this.$parent.showUpdateUserPassword(false);
    }

  },
  mounted(){
    // let user = JSON.parse(localStorage.getItem('account')).user;
    
  }
  
}
</script>

<style scoped>

.panel{
  max-height: 80%;
}

</style>
